import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

/**
 * useAuth Hook
 *
 * Provides access to authentication context.
 * Must be used within an AuthProvider wrapper.
 *
 * @throws Error if used outside of AuthProvider
 * @returns AuthContextType with user, session, loading state, and auth methods
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { user, signIn, signOut, loading } = useAuth();
 *
 *   if (loading) return <div>Loading...</div>;
 *
 *   return (
 *     <div>
 *       {user ? <p>Welcome {user.name}</p> : <p>Please sign in</p>}
 *     </div>
 *   );
 * }
 * ```
 */
export function useAuth() {
	const context = useContext(AuthContext);

	if (context === undefined) {
		throw new Error("useAuth must be used within an AuthProvider");
	}

	return context;
}
